const SHORT_MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export function formatShortDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return `${SHORT_MONTHS[d.getUTCMonth()]} ${d.getUTCDate()}`;
}

export function formatAge(iso: string, now: Date = new Date()): string {
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return "";
  const diffMs = Math.max(0, now.getTime() - then.getTime());
  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 1) return "now";
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  return `${days}d`;
}

export function channelLabel(
  channelName: string | undefined,
  channelId: string,
): string {
  const trimmed = channelName?.trim();
  if (trimmed && trimmed !== channelId) return `#${trimmed}`;
  // A chat app's composite id ("discord:<guild>:<channel>") is no name: the
  // app is the best label it has.
  const [app, ...rest] = channelId.split(":");
  return app && rest.length > 0
    ? `${app.charAt(0).toUpperCase()}${app.slice(1)}`
    : `#${channelId}`;
}
